const EXCLUDED_DOMAIN_KEYS = [
  'mavieprodecouverte',
  'equipeinterne',
  '0mediainterne',
  '0testdev',
  '0testequipe',
  'nosdroits',
  'tractdecouverte'
]

function normalizeKey (label) {
  return String(label || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/['’\s-]+/g, '')
    .trim()
}

export function isTrackingDomainIncluded (domain) {
  if (!domain || typeof domain !== 'object') {
    return false
  }

  if (domain?.application?.slug === 'disabled') {
    return false
  }

  const currentApplicationSlug = process.env.VUE_APP_APPLICATION
  if (currentApplicationSlug && domain?.application?.slug !== currentApplicationSlug) {
    return false
  }

  const normalizedKey = normalizeKey(domain.label)
  if (!normalizedKey) {
    return false
  }

  if (normalizedKey.includes('(demo)')) {
    return false
  }

  if (/^[0-7][\s.-]+/.test(String(domain.label || '').trim().toLowerCase())) {
    return false
  }

  if (EXCLUDED_DOMAIN_KEYS.includes(normalizedKey)) {
    return false
  }

  return true
}

export function filterTrackingDomains (domains) {
  const list = Array.isArray(domains) ? domains : []
  return list.filter(isTrackingDomainIncluded)
}
